export const CSRF_TOKEN_HEADER = "X-CSRFToken";
export const SERVER_API_PATH = "/api/v1";

export const PUBLISHING_API_PATH = `${SERVER_API_PATH}/publishing`;
export const PUBLICATIONS_API_PATH = `${PUBLISHING_API_PATH}/publications`;
